<template>
  <div>
    <v-dialog v-model="show" persistent max-width="290">
      <v-card>
        <v-card-title
          >Benutzer mit der email: {{ dataUser.email }}
          endgültig löschen?
        </v-card-title>
        <v-card-text
          >Diese Operation kann nicht rückgängig gemacht werden.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="
              show = false;
              yesOnClick();
            "
          >
            Ja
          </v-btn>
          <v-btn color="green darken-1" text @click.stop="show = false">
            Nein
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    dataUser: Object,
    deleteUser: ''
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    yesOnClick() {
      this.deleteUser(this.dataUser._id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/DeleteDialog.vue